// extracted by mini-css-extract-plugin
export default {"struturaFormInputs":"Desafio_struturaFormInputs__3Hl0h"};